
import { Link } from 'react-router-dom';
import CTCBanner from "../../public/assets/images/bg/ctc-image.png";
import CustomButton from '../CustomButton';
function CTC() {
    return (
        <>
            <div className="ctc-section-wrapper">
                <div className="container">
                    <div className="ctc-section">
                        <div className="title-section">
                            <div className="main-title">
                                <h2>Let’s Build The Future Together</h2>
                            </div>
                            <Link to="/contact-us">
                                <button type="submit" className="btn--primary2 mt-20">
                                   contact us<CustomButton />
                                </button>
                            </Link>
                        </div>
                        <div className="ctc-box">
                            <div className="ctc-slider">
                                <img src={CTCBanner} alt="CTC Banner" className='img-fluid' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default CTC;